import { Navigate } from 'react-router-dom'
import useAuthStore from '../../store/authStore'
import RouteTransitionFallback from '../brand/RouteTransitionFallback'

/**
 * SALTO:onboarding-10 · T2 · EL ALTA, ABIERTA. Sin sesión se entra igual —es lo que el tramo trae, la cuenta va al final—; con sesión y el alta ya
 * terminada se va a Today, que es lo único que `ProtectedRoute` decidía aquí. Mientras el perfil no está resuelto no se decide nada: con un perfil a
 * medio cargar, mandar a Today o al alta es echar una moneda (QA-E2E bug#3).
 *
 * Vive en su propio fichero, y no dentro de `App.js`, para que la puerta monte EXACTAMENTE el componente que monta la ruta servida en vez de leer el
 * texto del router. Y vive **fuera de `components/onboarding-v2/`**: `App.js` lo importa de forma ansiosa mientras el resto de esa carpeta se carga
 * perezosamente, y con el fichero dentro webpack lo metía en el chunk asíncrono del alta — el bundle servido moría con
 * `ReferenceError: Cannot access 'w' before initialization` y **todo el que abría el alta veía la pantalla de error**.
 */
export default function AltaAbierta({ children }) {
  const { user, profile, loading, profileResolved } = useAuthStore()
  if (loading) return <RouteTransitionFallback />
  if (user && !profileResolved) return <RouteTransitionFallback />
  if (user && profile?.onboarding_completed) return <Navigate to="/today" replace />
  return children
}
